module.exports = __webpack_public_path__ + "static/img/fenxiang.9170207.png";


//////////////////
// WEBPACK FOOTER
// ./static/tabbar/fenxiang.png
// module id = LyTU
// module chunks = 24